import { SelectList, ListItem, Button, Icons } from 'construct-ui';

/**
 * @deprecated
 * 
 * Instead, please use
 * ```
 * src\app\components\multi-select\multi-select.component.js
 * ```
 */
export default function multipleSelectListComponent() {
  let _attrs;
  let selectedList = [];
  let items = [];
  let colorList = [];
  let _id = "";
  let handleSelect = (e, id) => { };

  function renderLeftDiv(item) {
    let color = "";
    let colorArr = colorList.filter(x => x.code == item.code);
    if (colorArr.length == 1) {
      color = colorArr[0].color;
    }
    return m('div',
      (selectedList.indexOf(item.code) > -1) && m('.cui-icon.cui-icon-check',
        { "style": "margin-top:2px;color:#0095e8;float:left;margin-right:6px" },
        m('svg[viewBox="0 0 24 24"]', m('polyline[points="20 6 9 17 4 12"]')
        )
      ),
      !(selectedList.indexOf(item.code) > -1) && m('.cui-icon.cui-icon-check', { "style": "margin-top:2px;color:transparent;float:left;margin-right:6px" },
        m('svg[viewBox="0 0 24 24"]', m('polyline[points="20 6 9 17 4 12"]')
        )
      ),
      m('.work-type-indicator', { "style": "border-color:" + color + "; background-color:" + color + "" }
      )
    )
  }

  function renderItem(item) {
    if (colorList.length > 0) {
      return m(ListItem, {
        contentLeft: renderLeftDiv(item),
        label: item.name,//.toLocaleString(),
        selected: (selectedList.indexOf(item.code) > -1),
      })
    } else {
      return m(ListItem, {
        label: item.name,//.toLocaleString(),
        selected: (selectedList.indexOf(item.code) > -1),
      })
    }
  }

  function itemPredicate(query, item) {
    var xxx = item.name.toLowerCase().includes(query.toLowerCase());
    return xxx;
  }

  function handleSelectedItems(item) {
    if (item.code == "") {
      selectedList.splice(0, selectedList.length);
    } else if (selectedList.indexOf(item.code) > -1) {
      selectedList.splice(selectedList.indexOf(item.code), 1)
    } else selectedList.push(item.code);

    _attrs.handleSelect(selectedList, _id);
  }

  function renderLabel() {
    let selectedLabels = [];
    if (selectedList.length < 1) {
      return 'Choose...';
    } else if (selectedList.length < 3) {
      items.map(item => {
        if (selectedList.indexOf(item.code) > -1) {
          selectedLabels.push(item.name);
        }
      });
      return selectedLabels.join(", ");
    } else {
      return selectedList.length + " selected";
    }
  }

  return {
    oninit: ({ attrs }) => {
      _attrs = attrs;
      items = _attrs.items;
      selectedList = _attrs.selectedList;
      if (_attrs.handleSelect) {
        handleSelect = _attrs.handleSelect;
      }
      if (_attrs.id) {
        _id = _attrs.id;
      }
    },
    onupdate: ({ attrs }) => {
      selectedList = _attrs.selectedList;
      if (attrs.colorList) colorList = attrs.colorList;
      renderLabel();
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      items = _attrs.items;
      if (attrs.colorList) colorList = attrs.colorList;

      return m(".col-md-12",
        m("label.form-label",
          _attrs.label,
          _attrs.mandatory ? m('span', { "style": { "color": "red" } }, '*') : ''),
        m(SelectList, {
          closeOnSelect: false,
          items: items,
          checkmark: attrs.colorList ? attrs.colorList.length > 0 ? false : true : true,
          itemRender: renderItem,
          itemPredicate: itemPredicate,
          onSelect: handleSelectedItems,
          popoverAttrs: {
            hasArrow: false
          },
          trigger: m(Button, {
            align: 'left',
            compact: true,
            class: 'select-list',
            fluid: true,
            iconRight: Icons.CHEVRON_DOWN,
            outlined: true,
            label: renderLabel(),
          })
        }),
        _attrs.validate && !_attrs.isvalid &&
        m(
          'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
          m('small', _attrs.errorMessage)
        )
      );
    }
  };
}
